import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Input from "../../../components/ui/Input";

const AuditFilters = ({ filters, onFilterChange, entityTypes = [], onApplyFilters }) => {
  // Initialize custom dates from filters if they exist
  const [customFromDate, setCustomFromDate] = useState(() => {
    if (filters.dateRange === 'custom' && filters.fromDate) {
      return new Date(filters.fromDate).toISOString().split('T')[0];
    }
    return '';
  });
  const [customToDate, setCustomToDate] = useState(() => {
    if (filters.dateRange === 'custom' && filters.toDate) {
      return new Date(filters.toDate).toISOString().split('T')[0];
    }
    return '';
  });

  const eventTypeOptions = [
    { value: "all", label: "All Actions" },
    { value: "Create", label: "Create" },
    { value: "Update", label: "Update" },
    { value: "Delete", label: "Delete" },
    { value: "Distributed", label: "Distribution" },
  { value: "Sync", label: "Sync" },
    { value: "Approved", label: "Approved" },
  ];

  const dateRangeOptions = [
    { value: "last-24-hours", label: "Last 24 Hours" },
    { value: "last-7-days", label: "Last 7 Days" },
    { value: "last-30-days", label: "Last 30 Days" },
    { value: "last-90-days", label: "Last 90 Days" },
    { value: "custom", label: "Custom Range" },
  ];

  const entityTypeOptions = [
    { value: "all", label: "All Entities" },
  ...entityTypes.map(type => ({ value: type, label: type }))
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
 
    // Auto-apply if not a date range change (which has its own handler)
    if (key !== 'dateRange' && onApplyFilters) {
      onApplyFilters(newFilters);
    } else {
      onFilterChange(newFilters);
    }
  };

  const handleDateRangeChange = (value) => {
    const newFilters = { ...filters, dateRange: value };
 
    // Calculate actual dates based on preset
    const now = new Date();
    let fromDate = null;
    let toDate = now.toISOString();
    
    switch (value) {
   case 'last-24-hours':
        fromDate = new Date(now.getTime() - 24 * 60 * 60 * 1000).toISOString();
        break;
      case 'last-7-days':
        fromDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString();
    break;
      case 'last-30-days':
     fromDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000).toISOString();
     break;
      case 'last-90-days':
        fromDate = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000).toISOString();
      break;
      case 'custom':
        // Use existing custom dates or default to last 7 days
    fromDate = customFromDate ? new Date(customFromDate + 'T00:00:00').toISOString() : new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString();
        toDate = customToDate ? new Date(customToDate + 'T23:59:59').toISOString() : now.toISOString();
        
     // Set initial custom dates if empty
        if (!customFromDate) {
          const defaultFrom = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
          setCustomFromDate(defaultFrom.toISOString().split('T')[0]);
      }
        if (!customToDate) {
          setCustomToDate(now.toISOString().split('T')[0]);
 }
        break;
    default:
        fromDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString();
    }
    
    newFilters.fromDate = fromDate;
    newFilters.toDate = toDate;
    
    // Auto-apply for preset ranges, wait for manual apply for custom
  if (value !== 'custom' && onApplyFilters) {
      onApplyFilters(newFilters);
    } else {
      onFilterChange(newFilters);
    }
  };

  const handleCustomDateChange = (field, value) => {
    if (field === 'from') {
      setCustomFromDate(value);
      if (value) {
        const fromDate = new Date(value + 'T00:00:00').toISOString();
        handleFilterChange('fromDate', fromDate);
      }
} else {
      setCustomToDate(value);
      if (value) {
        const toDate = new Date(value + 'T23:59:59').toISOString();
  handleFilterChange('toDate', toDate);
  }
}
  };

  const handleApply = () => {
    if (onApplyFilters) {
      // Ensure dates are properly set for custom range
      const appliedFilters = { ...filters };
      if (filters.dateRange === 'custom') {
        if (customFromDate) {
   appliedFilters.fromDate = new Date(customFromDate + 'T00:00:00').toISOString();
 }
        if (customToDate) {
       appliedFilters.toDate = new Date(customToDate + 'T23:59:59').toISOString();
        }
   }
      onApplyFilters(appliedFilters);
    }
  };

  const handleReset = () => {
    setCustomFromDate('');
    setCustomToDate('');
    const defaultFilters = {
      eventType: 'all',
      dateRange: 'last-7-days',
      entityType: 'all',
      searchQuery: '',
      fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    toDate: new Date().toISOString(),
    };
    
    if (onApplyFilters) {
      onApplyFilters(defaultFilters);
    } else {
 onFilterChange(defaultFilters);
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
     <h3 className="font-semibold flex items-center gap-2">
        <Icon name="Filter" size={18} />
        Filters
   </h3>
        <button
      onClick={handleReset}
      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
     Reset Filters
        </button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
     {/* Search */}
     <div>
       <label className="block text-sm font-medium mb-1.5">Search</label>
   <div className="relative">
            <Icon
  name="Search"
   size={18}
         className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none z-10"
         />
 <input
      type="text"
        placeholder="Search events..."
        value={filters?.searchQuery || ''}
          onChange={(e) => handleFilterChange("searchQuery", e.target.value)}
 className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
            />
          </div>
        </div>

        {/* Action Type */}
        <div>
          <label className="block text-sm font-medium mb-1.5">Action</label>
          <select
      value={filters?.eventType || 'all'}
      onChange={(e) => handleFilterChange("eventType", e.target.value)}
    className="w-full h-10 px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
      >
        {eventTypeOptions.map(option => (
        <option key={option.value} value={option.value}>
    {option.label}
              </option>
            ))}
       </select>
        </div>

        {/* Entity Type */}
        <div>
          <label className="block text-sm font-medium mb-1.5">Entity Type</label>
        <select
  value={filters?.entityType || 'all'}
      onChange={(e) => handleFilterChange("entityType", e.target.value)}
        className="w-full h-10 px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
          >
            {entityTypeOptions.map(option => (
       <option key={option.value} value={option.value}>
        {option.label}
              </option>
        ))}
       </select>
    </div>

        {/* Date Range */}
        <div>
          <label className="block text-sm font-medium mb-1.5">Date Range</label>
     <select
value={filters?.dateRange || 'last-7-days'}
            onChange={(e) => handleDateRangeChange(e.target.value)}
            className="w-full h-10 px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
          >
      {dateRangeOptions.map(option => (
      <option key={option.value} value={option.value}>
  {option.label}
      </option>
       ))}
          </select>
  </div>
      </div>

      {/* Custom Date Range */}
      {filters?.dateRange === 'custom' && (
  <div className="mt-4 p-4 bg-muted/50 rounded-lg">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
    <label className="block text-sm font-medium mb-1.5">From Date</label>
        <Input
     type="date"
       value={customFromDate}
           onChange={(e) => handleCustomDateChange('from', e.target.value)}
      max={customToDate || new Date().toISOString().split('T')[0]}
        />
            </div>
            <div>
        <label className="block text-sm font-medium mb-1.5">To Date</label>
           <Input
       type="date"
    value={customToDate}
         onChange={(e) => handleCustomDateChange('to', e.target.value)}
         min={customFromDate}
        max={new Date().toISOString().split('T')[0]}
  />
     </div>
  </div>
   </div>
      )}

      {/* Apply Button */}
      <div className="mt-4 flex justify-end">
        <button
      onClick={handleApply}
      className="btn btn-primary"
        >
     <Icon name="Search" size={16} />
     Apply Filters
        </button>
      </div>
    </div>
  );
};

export default AuditFilters;
